//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationTabs",
  props: {
    pages: {
      type: Array,
      required: true
    },
    applicationId: {
      type: [String, Number],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  methods: {
    getLinkData(page) {
      return {
        name: page === "application" ? page : "application-" + page,
        params: {
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          agentUsername: this.agentUsername
        }
      };
    },
    getTabTitle(page) {
      return page === "filogix" ? "Expert" : this.$t(`application.pages.main-tabs.${page}`);
    }
  }
});